/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
function n(o) {
  const t = { horizontal: "left", vertical: "bottom" };
  return o && (t.horizontal = "right"), t;
}
function i(o) {
  const t = { horizontal: "left", vertical: "top" };
  return o && (t.horizontal = "right"), t;
}
export {
  n as getAnchorAlign,
  i as getPopupAlign
};
